// extracted by mini-css-extract-plugin
module.exports = {"input_label":"InputWithLabel_input_label__k_vLW"};